import { FeatureFlags } from '@iot-platform/models/common';
import { commonEnvironment } from './environment.common';

export const environment = {
  ...commonEnvironment,
  featureFlags: {
    ...commonEnvironment.featureFlags,
    [FeatureFlags.AllowAiAssistant]: false,
    [FeatureFlags.UploadToGoogleDrive]: true
  }
};
